/* global smartfield:true */

/**
 * Smartfield Object: This object builds and maintains smartfields.
 */
smartfield = function () {
	'use strict';

	var objSmartfield = {};
	var objDialog = dialog();
	var objDom	= dom();
	var objEntity = entity();
	var objAssessment = assessment();
	var objValidation = validation();
	var objImport = importData('import');
	var objHermes = hermes();

	/*
	 * Function buildDatasets
	 * Purpose: Create the dataset dropdown in the approval process dialog and stores it in the DOM.
	 * This entire function needs to be replaced with something a LOT smarter, like a model!
	 */
	objSmartfield.buildDatasets = function() {
		// Get the data sets (eventually, push additional ones in here)
		var datasets = [{
			type:'entity types',
			url: 'entityType',
			insert: 'ENTITY-TYPES'
		},{
			type:'role types',
			url: 'roleType',
			insert: 'ROLE-TYPES'
		}];

		var makeOption = function(data, type) {
			var escapedName = escapeUserInput(data.name);
			return '<option value="'+ type + '-' + data.id +'">&nbsp; &nbsp; &nbsp; '+ escapedName +'</option>';
		};

		$.get('/admin/entityType.json', {summary:1}, function(data) {
			var entityTypeOptions = '';
			$(data.types).each(function(i) {
				entityTypeOptions += makeOption(this,'entityType');
			});
			$('#dataset option[value="ENTITY-TYPES"]').replaceWith(entityTypeOptions);

			$.get('/admin/roleType.json', {}, function(data) {
				var roleTypeOptions = '';
				$(data.types).each(function(i) {
					roleTypeOptions += makeOption(this,'roleType');
				});
				$('#dataset option[value="ROLE-TYPES"]').replaceWith(roleTypeOptions);
				// Find all current smartfields on the page and fill them out with these options too
				$('.smartfield-option select[id$="dataset"]').each(function() {
					var select = $(this);
					$(select).children('option[value="ENTITY-TYPES"]').replaceWith(entityTypeOptions);
					$(select).children('option[value="ROLE-TYPES"]').replaceWith(roleTypeOptions);

					// Select the correct option based on the selected dataset
					var selectedOption = ($(select).attr('class')).match(/selected-(.*)/)[1];
					$(select).children('option').each(function() {
						if ($(this).val() === selectedOption) {
							$(this).prop('selected', true);
						}
					});
				});

			});
		});

		//  Load custom types
		$.ajax({
			url: '/smartfield.json',
			type: 'GET',
			data: {activeOnly: true},
			success: function(result){
				if (result.success > 0){
					var customTypeOptions = '';
					$(result.datasets).each(function(i) {
						customTypeOptions += makeOption(this,'customType');
					});
					$('option[value="CUSTOM-TYPES"]').replaceWith(customTypeOptions);
				}
			}
		});

		/*
		for(x=0; x< datasets.length; x++) {
			var url = '/admin';

			var replaceOption = $('#dataset option[value="'+ datasets[x].insert +'"]');
			$.get(url + '/' + datasets[x].url +'.json', {}, function(data) {
				var options = '';
				$(data.types).each(function(i) {
					options += '<option value="'+ data.types[i]['id'] +'">'+ data.types[i]['name'] +'</option>';
				});
				$(replaceOption).replaceWith(options);
			});
		}
		*/
	};

	/*
	 * Function loadSmartfieldData
	 * Purpose: Uses the dataset from the field to grab the correct dataset on the proposal
	 */
	objSmartfield.loadSmartfieldData = function(obj, disableDone) {
		var field = ($(obj).attr('class')).match(/\s(field-\d*)/);
		var dataset = ($(obj).attr('class')).match(/dataset-(\w*)-?(\d*)?/);
		var single = ($(obj).hasClass('single')) ? ' single' : '';
		var selectId = '#smartfield-select';
		var dropzone = $(obj).parents('.section-fieldset').find('.curriculog-smartfield-dropzone');

		var selectedItems = [];
		$(dropzone).children('.smartfield-item').each(function(i){
			i = {
				id : parseInt(($(this).attr('class')).match(/field-\d*-(\d*)/)[1], 10),
				parent : (($(this).attr('class')).match(/parent-(\d*)/) !== null) ? parseInt(($(this).attr('class')).match(/parent-(\d*)/)[1], 10) : 0
			};
			selectedItems.push(i);
		});

		// Get Data Set
		switch (dataset[1]) {
		case 'entities':
			objEntity.entityParentsSelect(selectId, 'list', function() {
				// Select items
				$(selectId).children('.select-field').each(function(i) {
					var id = parseInt(($(this).children('button').attr('class')).match(/value-(\d*)/)[1], 10);
					var parent = (($(this).children('button').attr('class')).match(/parent-(\d*)/) !== null) ? parseInt(($(this).children('button').attr('class')).match(/parent-(\d*)/)[1], 10) : 0;
					var itemIndex = getSelectedPosition(selectedItems, id);

					if ( (itemIndex !== undefined) && (selectedItems[itemIndex].parent === parent)) {
						$(this).addClass('active');
					}
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'objectives':
			objAssessment.objectiveDialog(selectId, function() {
				// Select items
				$(selectId).children('.select-field').each(function(i) {
					var id = parseInt(($(this).children('button').attr('class')).match(/value-(\d*)/)[1], 10);
					var itemIndex = getSelectedPosition(selectedItems, id);

					if (itemIndex !== undefined) {
						$(this).addClass('active');
					}
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'entityTypes':
			console.log('entityTypes');
			$.get('/entityType.json', {}, function(data) {
				$('#smartfield-select').contents().remove();
				$(data.types).each(function(index) {
					objSmartfield.buildDialog(this, selectedItems);
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'roleTypes':
			console.log('roleTypes');
			$.get('/roleType.json', {}, function(data) {
				$('#smartfield-select').contents().remove();
				$(data.types).each(function(index) {
					objSmartfield.buildDialog(this, selectedItems);
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'customTypes':
			$.get('/smartfield.json', {}, function(data) {
				$('#smartfield-select').contents().remove();
				$(data.datasets).each(function(index) {
					objSmartfield.buildDialog(this, selectedItems);
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'entityType':
			console.log('entityType: ' + dataset[2]);
			// Get the type from dataset[2]
			$.get('/entity:'+ dataset[2] +'/type.json', {}, function(data) {
				$('#smartfield-select').contents().remove();
				$(data.entities).each(function(index) {
					objSmartfield.buildDialog(this, selectedItems);
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'roleType':
			console.log('roleType: ' + dataset[2]);
			// Get the type from dataset[2]
			$.get('/roleType:'+ dataset[2] +'/type.json', {}, function(data) {
				$('#smartfield-select').contents().remove();
				$(data.roles).each(function(index) {
					objSmartfield.buildDialog(this, selectedItems);
				});
				Curriculog.Actions.log('smartfield-data-loaded')
			});
			break;
		case 'customType':
			console.log('customType: ' + dataset[2]);
			$.ajax({
				url: '/smartfield:' + dataset[2] + '.json',
				type: 'GET',
				success: function(result){
					if (result.success > 0){
						$(result.datasets).each(function(index, dataset){
							$('#smartfield-select').contents().remove();
							$(dataset.children).each(function(indexSub, value){
								objSmartfield.buildDialog(this, selectedItems);
							});
						});
					}
					Curriculog.Actions.log('smartfield-data-loaded')
				}
			});
			break;
		default:
			$('#growls').notify('create', 'warning-template', {
				text: 'No items available to add at this time.'
			});

			return false;
		}

		// Create the dialog
		var dialog = objDialog.createDOMDialog('curriculog-dialog-smartfield', function(dialog, defaults) {
			// Actions
			defaults.dialogClass = 'curriculog-dialog' + single;
			if ((dataset[1] === 'objectives') && ($('#createAssessments').val() === '1')) {
				defaults.buttons = {
					'Done': function() {
						assessmentObject.gatherAssessments(obj, true);
						$(this).dialog('close');
					},
					'Create New': function() {
						var items = {};
						items[0] = {
							categoryId : '',
							categoryName : '',
							assessmentId : '',
							assessmentValue : ''
						};
						assessmentObject.newProposalAssessment(obj, items);
						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};
				defaults.close = function(event, ui) {
					$('#smartfield-select').contents().remove();
					$('#smartfield-select').append('<li class="loading"></li>');
				};

			} else if ((dataset[1] === 'objectives') && ($('#createAssessments').val() === '0')) {
				defaults.buttons = {
					'Done': function() {
						assessmentObject.gatherAssessments(obj, false);
						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};
				defaults.close = function(event, ui) {
					$('#smartfield-select').contents().remove();
					$('#smartfield-select').append('<li class="loading"></li>');
				};

			} else {
				defaults.buttons = {
					'Done': function() {
						// If smartfield allows only one selection, clean out previous list, then add new item.
						if( ($(obj).hasClass('single')) && ($(obj).parents('.section-fieldset').find('.smartfield-item').length > 0) ) {

							var dialog = objDialog.createBasicWarningDialog('remove-smartfield-items', function(dialog, defaults) {

								var selection1 = $(obj).parents('.section-fieldset').find('.smartfield-item').text();
								var selection2 = $('#smartfield-select li.active button').text();

								selection1 = escapeUserInput(selection1);
								selection2 = escapeUserInput(selection2);

								// Message
								$(dialog).append('This smartfield only allows one selection. You have already selected '+ selection1 +'. ');
								$(dialog).append('Your new selection, '+ selection2 +', will replace it. ');
								$(dialog).append('Are you sure you want to replace ' + selection1 + '?');

								// Actions
								defaults.buttons = {
									'Replace Item': function() {
										$(obj).parents('.section-fieldset').find('.smartfield-item').remove();
										$('#smartfield-select li.active').each(function(i) {
											var buttonName = field[0]+'-'+($(this).children('button').attr('class')).match(/value-(\d*)/)[1];
											var buttonText = $(this).children('button').text();
											buttonText = escapeUserInput(buttonText);
											var parent = ($(this).children('button').attr('class')).match(/parent-(\d*)/);
											if (parent !== null) {
												parent = ' parent-'+parent[1];
											} else {
												parent = '';
											}
											var actions = '<div class="smartfield-actions"><a title="Remove Item" class="curriculog-widget delete-widget" href="#"></a></div>';
											$(dropzone).append('<div class="smartfield-item '+buttonName+ parent +' ">'+buttonText+actions+'</div>');

										});

										$('#smartfield-select').contents().remove();
										$('#smartfield-select').append('<li class="loading"></li>');

										proposalObject.saveField(field[1].replace('field-',''), 0, [0], function() {
											objSmartfield.saveSmartfieldCallback(obj);
										});
										objSmartfield.verticalStretch();

										$(this).dialog('close');
									},
									'Cancel': function() {
										$('#smartfield-select').contents().remove();
										$('#smartfield-select').append('<li class="loading"></li>');
										$(this).dialog('close');
									}
								};
								$(dialog).dialog(defaults);

							});

						} else {
							//remove the current selections - they are in the dialog too.

							$(dropzone).find('.smartfield-item').remove();

							//var entityIds = [];
							$('#smartfield-select li.active').each(function(i){

								// Clean up list if displaying "none selected"
								$(dropzone).find('.no-item').remove();

								var buttonName = field[0]+'-'+($(this).children('button').attr('class')).match(/value-(\d*)/)[1];
								var buttonText = $(this).children('button').text();
								var parent = ($(this).children('button').attr('class')).match(/parent-(\d*)/);
								if (parent !== null) {
									parent = ' parent-'+parent[1];
								} else {
									parent = '';
								}
								var actions = '<div class="smartfield-actions"><a title="Remove Item" class="curriculog-widget delete-widget" href="#"></a></div>';

								var escapedButtonText = escapeUserInput(buttonText);
								$(dropzone).append('<div class="smartfield-item '+buttonName+ parent +'">'+escapedButtonText+actions+'</div>');
								//entityIds[i] = ($(this).children('button').attr('class')).match(/value-(\d*)/)[1];
							});
							//console.log(entityIds);

							$('#smartfield-select').contents().remove();
							$('#smartfield-select').append('<li class="loading"></li>');

							proposalObject.saveField(field[1].replace('field-',''), 0, [0], function() {
								objSmartfield.saveSmartfieldCallback(obj);
							});
						}

						$('fieldset.required.error').each(function(index, smartfield){
							if ($(this).find('.smartfield-item').size() < 1) {
								objValidation.addError($(this).find('input'), '', true, true, function(){
									$('#curriculog-steps-column-decisions').find('button').attr('disabled', 'disabled').fadeTo('fast', 0.5);
								});
							} else {
								$($(this).find('input')).removeClass('error');
								$(this).removeClass('error');
								objValidation.removeError($(this).find('input'), '', function(){
									$(this).removeClass('error');
								}, function(){
									$('#curriculog-steps-column-decisions').find('button').removeAttr('disabled').fadeTo('fast', 1.0);
								});
							}
						});
						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
						$('#smartfield-select').contents().remove();
						$('#smartfield-select').append('<li class="loading"></li>');
					}
				};
			}

			$(dialog).dialog(defaults);

			// disable done button if we are adding a new objective instead of editing it.
			if (disableDone !== undefined && disableDone) {
				$('.ui-dialog-buttonpane button:contains("Done")').button('disable');
			} else {
				$('.ui-dialog-buttonpane button:contains("Done")').button('enable');
			}

		});
	};

	objSmartfield.buildDialog = function(data, selectedItems) {
		var selectId = '#smartfield-select';

		// Select the appropriate items
		var isActive = '';
		var itemIndex = getSelectedPosition(selectedItems, data.id);

		if ( (itemIndex !== undefined) && (selectedItems[itemIndex].id === data.id) ) {
			isActive = ' active';
		}

		var hasParent = '';
		if ( (itemIndex !== undefined) && (selectedItems[itemIndex].parent !== null) ) {
			hasParent = ' parent-'+selectedItems[itemIndex].parent;
		}

		$(selectId).append($('<li class="select-field'+ isActive +'"><button class="curriculog-add-widget value-'+ data.id + hasParent +'">' + escapeUserInput(data.name) + '</button></li>'));
	};


	objSmartfield.removeSmartfieldItem = function(obj) {
		var addlink = $(obj).closest('.section-fieldset').find('.add-smartfield-item');
		var fieldId = $(obj).closest('.section-fieldset').attr('class').match(/\sfield-(\d*)/)[1];

		var dialog = objDialog.createBasicWarningDialog('remove-smartfield', function(dialog, defaults) {
			// Message
			var name = '';
			var extraInstructions = '';
			var type = '';


			if ($(obj).parents('fieldset.widget-curriculum').size() > 0) {
				if ( $('#schema_icon').hasClass('active') ) {
					// core

					if ($(obj).parents('.smartfield-item').size() > 0 && !$(obj).parents('.smartfield-item').hasClass('customText')) {
						// course deleted
						name = 'the course, ' + $.trim($(obj).parents('.smartfield-item').text());
						extraInstructions = '<p>The course will only be removed from this core.</p>';

					} else if($(obj).parents('.smartfield-item').size() > 0 && $(obj).parents('.smartfield-item').hasClass('customText')) {
						// custom text deleted
						extraInstructions = '';
						name = 'the custom text, ' + $.trim($(obj).parents('.smartfield-item').text());

					} else {
						// core deleted
						name = 'the core, ' + $.trim($(obj).parents('fieldset:eq(0)').children('h3').text());
						extraInstructions = '<p>The course(s) within this core will not be removed from the curriculum courses within this proposal.</p>';
					}
				} else {
					extraInstructions = '<p>The course will be removed from the schema.</p>';
				}
			}

			if (name.length < 1) {
				name = $(obj).parents('.smartfield-item').text();
			}

			$(dialog).append('<p>Are you sure you want to remove ' + name + '?</p>' + extraInstructions);

			// Actions
			defaults.buttons = {
				'Remove Item': function() {
					if ($(obj).parents('fieldset.widget-curriculum').size() > 0) {
						var smartfieldItem;
						if ( $('#schema_icon').hasClass('active') ) {
							// schema

							// cores
							var sharedCore = ($(obj).closest('.course-list').hasClass('shared-core-courses')) ? 1 : 0;
							smartfieldItem = $(obj).parents('fieldset.curriculog-smartfield-dropzone');
							var child = false;

							// courses and custom text
							if (sharedCore || ($(obj).parents('fieldset.system-required-proposalCurriculum').size() > 0) ) {
								child = true;

								smartfieldItem = $(obj).parents('.smartfield-item');

								if ($(obj).parents('.smartfield-item:eq(0)').hasClass('customText')) {
									child = false;
								}
							}

							proposalObject.removeCurriculumItem($(smartfieldItem), child);
						} else {
							// course
							smartfieldItem = $(obj).parents('.smartfield-item');
							proposalObject.removeCurriculumItem($(smartfieldItem), false);
						}
					} else {
						if ( ($(obj).parents('.curriculog-smartfield-dropzone').children('.smartfield-item')).length === 1 ) {
							$(obj).parents('.curriculog-smartfield-dropzone').append($('<div class="no-item">None Selected</div>'));
							/* Mark as needing to be completed
							 *if ($(obj).parents('fieldset:first').hasClass('required')) {
								objValidation.addError($(obj).parents('.curriculog-smartfield-dropzone').find('input'), '', true, true, function(){
									$("#curriculog-steps-column-decisions").find("button").attr('disabled', 'disabled').fadeTo('fast', 0.5);
								});
							}*/
						}
						$(obj).parents('.smartfield-item').remove();
						proposalObject.saveField(fieldId, 0, [0], function() {
							objSmartfield.saveSmartfieldCallback(addlink);
						});

						objSmartfield.verticalStretch();
					}
					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);

		});

	};

	objSmartfield.saveSmartfieldCallback = function(obj) {
		// CALLBACK FOR REFRESHING THE STEPS
		// return entityIds as comma delimited list
		var data = {};
		var dropzone = $(obj).parents('.section-fieldset').find('.curriculog-smartfield-dropzone');
		data.display = 'getUsers';

		Curriculog.Actions.log('smartfield-saved');

		if($(dropzone).hasClass('system-required-proposalEntity')) {
			// Load in the steps for the selected entity/entities
			proposalObject.getUsers();

		} else {
			objSmartfield.verticalStretch();
		}
	};

	var getSelectedPosition = function(array, id) {
		var myPosition;
		for (var i = 0; i < array.length; i++) {
			if (array[i].id === id) {
				myPosition = i;
				break;
			}
		}
		return myPosition;
	};

	objSmartfield.verticalStretch = function() {
		var col1 = '#curriculog-fields-column-content';
		var col2 = '#curriculog-steps-column-content';
		var domObject = dom();
		domObject.verticalStretchForm(col1, col2, function() {
			if ($('#comments-list').size() > 0) {
				$('#comments-list').parent()
					.css('maxHeight', $('#curriculog-fields-column-content').height() - 150)
					.css('height', $('#comments-list').css('height'));
			}
		});
	};

	objSmartfield.refreshSmartfieldDialog = function(id){
		//if (typeof(id) == undefined){
		if (id === undefined) {
			id = $('#dataset-id-dialog').val();
		}

		var dialog = '#smartfield-dataset-dialog';
		$('div.qtip-active').css('display', 'none').removeClass('qtip-active');

		if (id > 0) {
			$.ajax({
				url: '/smartfield:' + id + '.json',
				type: 'GET',
				success: function(result){
					if (result.success > 0){
						$(result.datasets).each(function(index, dataset){
							$('#dataset-details-name').val(dataset.name);
							$('#dataset-details-id').val(dataset.id);

							$(dialog).find('ul.datasets').empty();
							
							var disabled = '';
							var locationDatasetId = $('#locations-dataset-id').val();
	
							if (id == locationDatasetId){
								var disabled = 'disable-delete';
							};

							$(dataset.children).each(function(indexSub, value){
								var escapedName = escapeUserInput(value.name);
								var listItem = '<li id="dataset-' + value.id + '-dialog" class="status-' + value.status + '">' +
									'<span class="dataset-name">' + escapeUserInput(value.name) + '</span>' +
									'<div class="dataset-actions">' +
									'<a href="#" class="curriculog-widget remove-widget ' + disabled + '" title="Delete Dataset Value" role="button"><span class="screen-reader-text">Delete ' + escapeUserInput(value.name) + '</span></a>' +
									'</div></li>';

								$(dialog).find('ul.datasets').append(listItem);

								$('#dataset-' + value.id + '-dialog .curriculog-widget[title]').each(function(){
									$(this).qtip({
										content: {text: false},
										style: {tip: true}
									});
								});

							});

							if ( $(dialog).find('ul.datasets li').size() < 1 ) {
								$(dialog).find('ul.datasets').append('<li class="no-values">No values have been added to this dataset.</li>');
							}

						});

						$(dialog).find('#dataset-values-list').unmask();



					}

				}
			});

		}

	};

	objSmartfield.validateDataset = function() {
		$.validity.start();
		$("#dataset-values-name").require();
		var result = $.validity.end();
		return result.valid;
	};

	objSmartfield.addDatasetValue = function(){

		var data = {};
		data['id'] = $('#dataset-details-id').val().trim();
		data['value'] = $('#dataset-values-name').val().trim();

		if (objSmartfield.validateDataset()) {
			$.ajax({
				url: '/smartfield.json',
				type: 'PUT',
				data: JSON.stringify(data),
				beforeSend: function() {
					$('#dataset-values-list').mask('Loading');
				},
				success: function(result){
					if (result.success > 0){
						$('#dataset-values-name').val('');
						objSmartfield.refreshSmartfieldDialog(data.id);
					}
					$('#dataset-values-list').unmask();
				}
			});
		}
	};
	/***
	 * checkConditionalSteps
	 * Checks if dataset value is being used as a conditional value for a
	 * active approval process step or unlaunched proposal
	 ***/

	objSmartfield.checkConditionalSteps = function(data){
		$.ajax({
			url: '/admin/approvalProcessStep/getByCondition.json',
			type: 'GET',
			data: data,
			beforeSend: function() {
				$('#dataset-values-list').mask('Loading');
			},
			complete: function(){
				$('#dataset-values-list').unmask();
			},
			success: function(result){
				var results = result.result;
				if ( results.success === 1 ){
						objSmartfield.removeDatasetValue(data.datasetValueId);
				} else {
					// todo: display error message
					var warningDialog = objDialog.createDOMWarningDialog(
						'remove-smartfield-warning-dialog',
						function(dialog, defaults){
							var $dialog = $(dialog);
							$dialog.find('ul.warning-list').empty();
							switch(data.type){
								case 'datasetValue':
									$dialog.find('.type').text('dataset value');
									break;
								case 'dataset':
									$dialog.find('.type').text('dataset')
									break;
							}
							_.each(results.warnings, function(warning){
									var warningItem = $('<li />');
									if (warning.type === 'proposal'){
										warningItem.text("Proposal: " + warning.name + " (Step: " + warning.stepName + ")");
										warningItem.wrap('<a href="/proposal:' + warning.id + '/form"></a>')
									} else if ( warning.type === 'approval-process') {
										warningItem.text("Approval Process: " + warning.name + " (Step: " + warning.stepName +")");
										warningItem.wrap('<a href="/admin/approvalProcess:' + warning.id + '/form"></a>')
									}
									$dialog.find('ul.warning-list').append(warningItem.parent());
							});

							var numProposalWarnings = _.where(results.warnings, {type: 'proposal'}).length;
							var numAPWarnings = _.where(results.warnings, {type: 'approval-process'}).length;
							if ( numProposalWarnings > 0 ){
								$dialog.find('.proposal-warning').show();
							} else {
								$dialog.find('.proposal-warning').hide();
							}

							if ( numAPWarnings > 0 ){
								$dialog.find('.ap-warning').show();
							} else {
								$dialog.find('.ap-warning').hide();
							}

							if ( numProposalWarnings > 0 && numAPWarnings > 0 ){
								$dialog.find('.both-warnings').show();
							} else {
								$dialog.find('.both-warnings').hide();
							}

							defaults.buttons = {
								'OK': function() {
									$(this).dialog('close');
								}
							};
							$dialog.dialog(defaults);
						}
					);

				}

			},
			error: function(result){
				growlError('Error', 'Unable to remove dataset value. Please try again or contact a system administrator.');
			}
		});

	};

	/**
	 * Remove a dataset value
	 */
	objSmartfield.removeDatasetValue = function(datasetValue){

		var data = {
			valueId : datasetValue
		};

		$.ajax({
			url: '/smartfield.json',
			type: 'PUT',
			data: JSON.stringify(data),
			beforeSend: function() {
				$('#dataset-values-list').mask('Loading');
			},
			success: function(result){
				if (result.success > 0){
					objSmartfield.refreshSmartfieldDialog($('#dataset-details-id').val().trim());
				}
				$('#dataset-values-list').unmask();
			}
		});
	};



	objSmartfield.importDataset = function(dataset) {
		var datasetID = $('#dataset-details-id').val();

		var i, items = [];
		for (i = 0; i < dataset.length; i++) {
			items.push({
				datasetID: datasetID,
				value: dataset[i],
				status: 'active'
			});
		}

		$.ajax({
			url: '/smartfield/importDataset.json',
			type: 'PUT',
			data: {
				items: JSON.stringify(items)
			},
			beforeSend: function() {
				objDom.addLoadingMask('#dataset-values-list');
			},
			success: function(result){
				objSmartfield.refreshSmartfieldDialog(datasetID);
				objDom.removeMask('#dataset-values-list');
			}
		});
	};

	objSmartfield.editSmartfieldDatasetValues = function(smartfieldId, callback) {
		// get isMapped from json
		objHermes.checkHermes(function(isMapped) {

			var dialog = objDialog.createDOMDialog('smartfield-dataset-dialog', function(dialog, defaults) {
				//defaults.width = 800;

				if (smartfieldId === 0) {
					$(dialog).find('#dataset-values-form').find('input, button').attr('disabled', true);
					$('#dataset-details-name').val('');
					$('#dataset-details-id').val('');
					$(dialog).find('ul.datasets').empty();

				} else {

					$('.dataset-values-import').removeAttr('disabled');

					// get isMapped from json
					if (isMapped == "1") {

						objHermes.getImportStatus(function(success) {
							$(dialog).find('#dataset-values-form').find('input, button').removeAttr('disabled');
						});
					} else {
						$(dialog).find('#dataset-values-form').find('input, button:not(.dataset-values-import)').removeAttr('disabled');
					}

					objSmartfield.refreshSmartfieldDialog(smartfieldId);

				}

				// Actions
				defaults.buttons = {
					'Close': function() {
						$(this).dialog('close');
					},
					Cancel : function() {
						$(this).dialog('close');
					}
				};

				$(dialog).on('click', '.dataset-details-update', function (event){
					event.preventDefault();
					var objSettings = settings();
					objSettings.saveSmartfieldDataset();
				});

				$(dialog).on('click', '.remove-widget', function(event){
					event.preventDefault();
					var data = {
						type: 'datasetValue',
						datasetValueId: $(this).closest('li').attr('id').match(/dataset-(.*)-dialog/)[1]
					};
					objSmartfield.checkConditionalSteps(data);
				});

				$(dialog).on('click', '.dataset-values-import', function(event){
					event.preventDefault();

					// if hermes maps exis, offer option to import from hermes or import from csv
					if(isMapped == '1') {
						objSmartfield.availableExternalSources('customTypes', function(){
							$('#smartfield-dataset-dialog').dialog('close');
						});

					} else {

						// automatically trigger dialog for csv upload
						var uploadDialog = objDialog.createDOMDialog('new-smartfield-dataset-dialog', function(uploadDialog, defaults) {
							$('#import_data_subLocation').val($('#dataset-details-name').val().trim());
							$('#import_data_id').val($('#dataset-details-id').val());

							// Actions
							defaults.buttons = {
								'Upload File': function() {
									// upload the file
                  objSmartfield.startUpload();
									$(this).dialog('close');
								},
								Cancel: function() {
									// STUFF
									$(this).dialog('close');
								}
							};
							$(uploadDialog).dialog(defaults);

						});
						$(uploadDialog).dialog('close');
					}
				});

				$(dialog).on('click', '.dataset-values-add', function(){
					objSmartfield.addDatasetValue();
				});

				$(dialog).on('click', '.dataset-values-reset', function(){
					$('#dataset-values-name').val('');
				});


				defaults.close = function(event, ui) {
					$(dialog).off('click','input');
					$(dialog).off('click', '.dataset-details-update');
					$(dialog).off('click', '.remove-widget');
					$(dialog).off('click', '.dataset-values-import');
					$(dialog).off('click', '.dataset-values-add');
					$(dialog).off('click', '.dataset-values-reset');

					// refresh main list
					if (callback) {
						callback();
					}
				};

				$(dialog).dialog(defaults);

			});
		});

	};

	objSmartfield.updateSmartfieldDataset = function(changeStatus, precall, callback){

		if (callback) {
			precall();
		}
		var data = {};

		if (!changeStatus) {
			data.id = $('input[name="dataset-id-dialog"]').val().trim();
			data.name = $('input[name="dataset-name-dialog"]').val().trim();
		} else {
			data.id = $(changeStatus).attr('id').replace('dataset-', '').trim();

			if (($(changeStatus).attr('class')).match(/status-(.*)/)[1].trim() === 'active') {
				data.status = 'inactive';
			} else {
				data.status = 'active';
			}
		}

		$.ajax({
			url: '/smartfield.json',
			type: 'PUT',
			data: JSON.stringify(data),
			success: function(result){
				if (result.success > 0){
					if (callback) {
						callback();
					}
				}
			}
		});
	};

	objSmartfield.availableExternalSources = function(type, callback, options){
		var count = 0;

		if (type === undefined){
			type = 'course';
		}

		if (options === undefined){
			options = {};
			//options = '';
		}

		var dialog = objDialog.createBasicDialog('import-dialog', 'Import Options', function(dialog, defaults) {
			// Message
			$(dialog).append('<p>Please select a method to import a custom dataset.</p>');

			// Actions
			defaults.buttons = [{
				id : 'connect-external-button',
				text : 'Import from Integration Manager',
				click: function() {
					// select external

					var url = '/hermes?display=hermesAvailableMap&method=types';
					//objHermes.loadWindow(url,'700','500');
					//objHermes.loadWindow(url, popups);
					objHermes.loadWindow(url);

					$(dialog).dialog('close');

					//callback && callback();
				}
			}];

			var datasetId = $('#dataset-details-id').val();
			var locationsDatasetId = $('#locations-dataset-id').val();


			if (datasetId != locationsDatasetId) {

				defaults.buttons.push({
					text: 'Import from File',
					id: 'import-from-file',
					click: function() {
	
						var uploadDialog = objDialog.createDOMDialog('new-smartfield-dataset-dialog', function(uploadDialog, defaults) {
							$('#import_data_subLocation').val($('#dataset-details-name').val().trim());
							$('#import_data_id').val($('#dataset-details-id').val());
	
							// Actions
							defaults.buttons = {
								'Upload File': function() {
									// upload the file
									objSmartfield.startUpload();
									$(this).dialog('close');
								},
								Cancel: function() {
									// STUFF
									$(this).dialog('close');
								}
							};
							$(uploadDialog).dialog(defaults);
	
						});
						$(dialog).dialog('close');
					}
				});
				
			}	

			defaults.buttons.push({
				id : 'cancel-import',
				text : 'Cancel',
				click : function() {
					$(dialog).dialog('close');
				}
			});

			defaults.close = function(event, ui) {
				$(dialog).remove();
			};

			$(dialog).dialog(defaults);

		});
	};

	objSmartfield.previewDataset = function(id, callback){
		$.ajax({
			url: '/smartfield:' + id + '.json',
			type: 'GET',
			success: function(result){
				if (callback) {
					callback(result);
				}
			}
		});
	};

  objSmartfield.startUpload = function () {
    objDom.addLoadingMask('#dataset-values-list');
    var s3FormData = new FormData(document.forms['file-upload-form']);
    var request = new XMLHttpRequest();
    request.onload = function() {
      objDom.removeMask('#dataset-values-list');
      objSmartfield.refreshSmartfieldDialog($('#dataset-details-id').val());
      var result = JSON.parse(request.response);
      if (result.success <= 0) {
        $('#growls').notify("create","warning-template", {
          title: 'Import Error',
          text: result.message
        });
      }
    };
    request.open('POST', location.href.replace('admin/settings', 'smartfield/upload.json'));
    request.send(s3FormData);
  };

	return objSmartfield;
};
